import React from 'react'
import PropTypes from 'prop-types'
//utils
import { getUpgradeBusinessAccountURL } from '../../../../utils/app-utils'
import { useMessage } from '../../../../hooks'
//components
import { NavLink } from 'react-router-dom'
import { CloseSmIcon, Link } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { useApplicationContext } from '../../../../context/ApplicationContext'
//constants
export const DEFAULT_DIALOG = 'DEFAULT_DIALOG'
export const WEBLLS_REMEMBERED_USER_DIALOG = 'WEBLLS_REMEMBERED_USER_DIALOG'
export const UNAUTHORIZED_LIVE_ENV_ROUTE_DIALOG =
  'UNAUTHORIZED_LIVE_ENV_ROUTE_DIALOG'
export const UNAUTHORIZED_LIVE_ENV_ROUTE_APPS_DIALOG =
  'UNAUTHORIZED_LIVE_ENV_ROUTE_APPS_DIALOG'
export const UNAUTHORIZED_LIVE_ENV_ROUTE_SANDBOX_DIALOG =
  'UNAUTHORIZED_LIVE_ENV_ROUTE_SANDBOX_DIALOG'
export const UNAUTHORIZED_LIVE_ENV_ROUTE_HOME_DIALOG =
  'UNAUTHORIZED_LIVE_ENV_ROUTE_HOME_DIALOG'
export const UNCONFIRMED_EMAIL_DIALOG = 'UNCONFIRMED_EMAIL_DIALOG'
export const UNCONFIRMED_EMAIL_SECONDARY_USER_DIALOG =
  'UNCONFIRMED_EMAIL_SECONDARY_USER_DIALOG'
export const MINIMAL_ACCOUNT_DIALOG = 'MINIMAL_ACCOUNT_DIALOG'
export const MISSING_SB_ACCOUNT_DETAILS_DIALOG =
  'MISSING_SB_ACCOUNT_DETAILS_DIALOG'
export const TopNavToggleMessage = ({
  dialogType,
  onCloseHandler,
  accountType,
}) => {
  const localizedMsg = useMessage()
  const { webLLSLogoutUrl, enviroment, user } = useApplicationContext()
  const dialogTypes = {
    [DEFAULT_DIALOG]: {
      title: 'top-nav.message.title',
      body: 'top-nav.message.body',
      linkText: 'top-nav.message.link',
      href: getUpgradeBusinessAccountURL({ accountType }),
      linkTarget: '_blank',
    },
    [WEBLLS_REMEMBERED_USER_DIALOG]: {
      title: 'top-nav.message.title',
      body: 'top-nav.message.weblls.body',
      linkText: 'top-nav.message.weblls.link',
      href: webLLSLogoutUrl,
    },
    [UNAUTHORIZED_LIVE_ENV_ROUTE_DIALOG]: {
      title: 'top-nav.app.details.switch.title',
      body: 'top-nav.app.details.message.body',
      linkText: 'top-nav.app.details.switch.message.link',
      href: `/applications/${enviroment}`,
    },
    [UNAUTHORIZED_LIVE_ENV_ROUTE_APPS_DIALOG]: {
      title: 'top-nav.app.details.switch.title',
      body:
        localizedMsg('top-nav.app.details.message.body') +
        localizedMsg('top-nav.app.details.switch.apps.credentials'),
      linkText:
        localizedMsg('top-nav.app.details.switch.message.link') +
        localizedMsg('top-nav.app.details.switch.apps.credentials'),
      href: `/applications`,
    },
    [UNAUTHORIZED_LIVE_ENV_ROUTE_SANDBOX_DIALOG]: {
      title: 'top-nav.app.details.switch.title',
      body:
        localizedMsg('top-nav.app.details.message.body') +
        localizedMsg('top-nav.app.details.switch.sandbox.accounts'),
      linkText:
        localizedMsg('top-nav.app.details.switch.message.link') +
        localizedMsg('top-nav.app.details.switch.sandbox.accounts'),
      href: `/accounts`,
    },
    [UNAUTHORIZED_LIVE_ENV_ROUTE_HOME_DIALOG]: {
      title: 'top-nav.app.details.switch.title',
      body:
        localizedMsg('top-nav.app.details.message.body') +
        localizedMsg('top-nav.app.details.switch.home'),
      linkText:
        localizedMsg('top-nav.app.details.switch.message.link') +
        localizedMsg('top-nav.app.details.switch.home'),
      href: `/`,
    },
    [UNCONFIRMED_EMAIL_DIALOG]: {
      title: 'top-nav.message.title',
      body: 'top-nav.message.unconfirmed.email.body',
      linkText: 'top-nav.message.unconfirmed.email.link',
      href: 'https://www.paypal.com/businessprofile/settings/email',
    },
    [UNCONFIRMED_EMAIL_SECONDARY_USER_DIALOG]: {
      title: 'top-nav.message.title',
      body: 'top-nav.message.unconfirmed.email.secondary.body',
      showEmail: true,
      linkText: 'top-nav.message.unconfirmed.email.secondary.link',
      href:
        'https://www.paypal.com/my/cshelp/article/how-do-i-confirm-my-email-address-help138',
    },
    [MINIMAL_ACCOUNT_DIALOG]: {
      title: 'top-nav.message.title',
      body: 'top-nav.message.minAccount.title',
      linkText: 'top-nav.message.minAccount.link',
      href: 'https://www.paypal.com/mep/dashboard',
    },
    [MISSING_SB_ACCOUNT_DETAILS_DIALOG]: {
      title: 'top-nav.app.nvp.soap.switch.title',
      body: localizedMsg('top-nav.app.nvp.soap.switch.body'),
      linkText:
        localizedMsg('top-nav.app.details.switch.message.link') +
        localizedMsg('top-nav.app.details.switch.apps.credentials'),
      href: `/applications`,
    },
  }

  return (
    <div className="dev_dash__top_nav_switcher-message-container">
      <div className="dev_dash__top_nav_switcher-message-header">
        <div className="dev_dash__top_nav_switcher-message-title">
          <Message id={dialogTypes[dialogType].title} />
        </div>
        <div className="dev_dash__top_nav_switcher-message-close">
          <CloseSmIcon style={{ cursor: 'pointer' }} onClick={onCloseHandler} />
        </div>
      </div>
      <div className="dev_dash__top_nav_switcher-message-body">
        <div>
          <Message
            id={dialogTypes[dialogType].body}
            email={dialogTypes[dialogType].showEmail ? user.email : ''}
            strong={(innerMsg) => <strong>{innerMsg}</strong>}
          />
        </div>
        <div className="dev_dash__top_nav_switcher-message-body-link">
          {dialogTypes[dialogType].href.startsWith('https://') ? (
            <Link
              href={dialogTypes[dialogType].href}
              onClick={onCloseHandler}
              target={dialogTypes[dialogType].linkTarget}
            >
              <Message id={dialogTypes[dialogType].linkText} />
            </Link>
          ) : (
            <Link
              as={NavLink}
              to={dialogTypes[dialogType].href}
              onClick={onCloseHandler}
            >
              <Message id={dialogTypes[dialogType].linkText} />
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

TopNavToggleMessage.propTypes = {
  dialogType: PropTypes.string,
  onCloseHandler: PropTypes.func.isRequired,
  accountType: PropTypes.string,
}
TopNavToggleMessage.defaultProps = {
  dialogType: DEFAULT_DIALOG,
}

export default TopNavToggleMessage
